import store from "../store/store";

// Added to the sign-out confirmation when the open guide has changes that
// aren't saved (4.10.55, 2026-10-26): signing out opens the sample guide, so
// they'd be lost. "Unsaved" = a guide never saved that has places, or a saved
// one flagged after a big change (GuideHasUnsavedChanges).
const signOutWarning = () => {
  const state = store.getState();
  const places = window.guide_obj?.places?.placesList?.length || 0;
  const neverSaved = state.guide_meta?.guide_info_id == null && places > 0;
  if (!neverSaved && state.GuideHasUnsavedChanges !== true) return "";
  const name = window.guide_obj?.attributes?.guide_name || "this guide";
  return ` "${name}" has changes that aren't saved — they'll be lost. Cancel and Save first to keep them.`;
};

export default signOutWarning;
